<div class="dialog-header">
  <span>Create New Event</span>
  <button class="dialog-header-close" mat-icon-button [mat-dialog-close]="false" (click)="dialogRef.close(false)">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="dialog-container" *ngIf="object.keys(event)?.length > 0">

  <form #form="ngForm" class="dialog-body" (ngSubmit)="form.valid && createEvent(event, data.buttonText)">

    <label class="required-label">Event name</label>
    <input type="text" class="form-control" [(ngModel)]="event.event_name" name="eventName" required
      #eventName="ngModel" />
    <div *ngIf="(eventName.invalid && eventName.touched) || (form.submitted && eventName.invalid)" class="error">
      Event name is required
    </div>

    <div class="grid-2">
      <div>
        <label>Event type</label>
        <select [(ngModel)]="event.type" name="eventType" class="form-control" required #eventType="ngModel">
          <option *ngFor="let type of eventTypes" [value]="type.value">{{ type.label }}</option>
        </select>
        <div *ngIf="(eventType.invalid && eventType.touched) || (form.submitted && eventType.invalid)" class="error">
          Event type is required
        </div>
      </div>

      <div>
        <label class="required-label">Event Date</label>
        <input type="date" class="form-control" [(ngModel)]="event.date" name="eventDate" required
          #eventDate="ngModel" />
        <div *ngIf="(eventDate.invalid && eventDate.touched) || (form.submitted && eventDate.invalid)" class="error">
          Event date is required
        </div>
      </div>
    </div>

    <div class="grid-2">
      <div>
        <label class="required-label">Start Time</label>
        <input type="time" class="form-control" [(ngModel)]="event.start_time" name="startTime" required
          #startTime="ngModel" />
        <div *ngIf="(startTime.invalid && startTime.touched) || (form.submitted && startTime.invalid)" class="error">
          Start time is required
        </div>
      </div>
      <div>
        <label class="required-label">End Time</label>
        <input type="time" class="form-control" [(ngModel)]="event.end_time" name="endTime" required
          #endTime="ngModel" />
        <div *ngIf="(endTime.invalid && endTime.touched) || (form.submitted && endTime.invalid)" class="error">
          End time is required
        </div>
      </div>
    </div>

    <div>
      <label>Remind</label>
      <select [(ngModel)]="event.reminder" name="reminder" required class="form-control" #reminder="ngModel">
        <option *ngFor="let reminder of reminders" [value]="reminder">{{ reminder }}</option>
      </select>
      <div *ngIf="(reminder.invalid && reminder.touched) || (form.submitted && reminder.invalid)" class="error">
        Reminder is required
      </div>
    </div>

    <div class="participants">
      <div class="participants-header">
        <label class="required-label">Participants</label>
        <a (click)="addParticipants()" style="cursor: pointer;">+ Add Participants</a>
      </div>
      <div class="participant-list">
        <div style="display: flex;text-align: center; justify-content: center;color: red;"
          *ngIf="form.submitted && (!event?.event_attendees?.length)">
          <br>*Add participants*
        </div>
        <div class="participant" *ngFor="let p of event.event_attendees">
          <span>{{ p.name }}</span>
          <span class="role {{ p.role | lowercase }}">{{ p.role }}</span>
          <span class="status">Invited</span>
        </div>
      </div>
    </div>
    <div class="meeting-link-container">
      <label class="required-label">Meeting Link</label>
      <button *ngIf="!event.meeting_link" mat-button color="primary" type="button" (click)="generateMeetingLink()"
        class="generate-link-btn">
        Generate
      </button>
    </div>

    <input type="text" class="form-control" [(ngModel)]="event.meeting_link" name="meetingLink" required
      #meetingLink="ngModel" />
    <div *ngIf="event.meeting_code">Meeting code: {{ event.meeting_code }}</div>

    <div *ngIf="(meetingLink.invalid && meetingLink.touched) || (form.submitted && meetingLink.invalid)" class="error">
      Meeting Link is required
    </div>

    <label>Description</label>
    <textarea rows="4" [(ngModel)]="event.description" name="description" class="form-control"
      #description="ngModel"></textarea>
    <!-- <div *ngIf="(description.invalid && description.touched) || (form.submitted && description.invalid)" class="error">
      Description is required
    </div> -->

    <button type="submit" class="create-btn" [disabled]="form.invalid" [mat-dialog-close]="true"
      (click)="dialogRef.close(true)">{{data.buttonText||'Create'}}</button>
  </form>

</div>

<ng-template #participantDialog>
  <div class="dialog-header">
    <span>Select participants</span>
    <button class="dialog-header-close" mat-icon-button [mat-dialog-close]="false" (click)="dialogRef.close(false)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <!-- <div  class="attendees_header" >Select participants</div> -->

  <div class="email_dialog-body">
    <div class="email_search-box">
      <input class="form-control" placeholder="Search or Add user by email" [(ngModel)]="searchTerm">
    </div>

    <div class="participant-lists">
      <div *ngFor="let user of filteredParticipants()" class="participant-row">
        <mat-checkbox [checked]="isSelected(user)" (change)="toggleSelection(user)">
          {{ user.name }}
        </mat-checkbox>
        <span class="role" [style.color]="user.color">
          <span class="icon">{{ user.icon }}</span> {{ user.role }}
        </span>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button mat-button (click)="dialogRef.close()">Back</button>
    <button type="submit" style="width: 80px;" class="create-btn" (click)="confirmSelection()">Done</button>
  </div>
</ng-template>